/**
 * Configuração centralizada das URLs da API
 * 
 * Detecta automaticamente o ambiente:
 * - localhost/127.0.0.1 → usa API local (http://localhost:5159/api)
 * - produção → usa API de produção (https://api.gettel.cloud/api)
 */

// Detecta se está rodando em ambiente local
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname === '');

// URLs para cada ambiente
const LOCAL_API_URL = 'http://localhost:5159/api';
const LOCAL_WHATSAPP_URL = 'http://localhost:5159';
const PROD_API_URL = 'https://api.gettel.cloud/api';
const PROD_WHATSAPP_URL = 'https://api.gettel.cloud';

export const API_CONFIG = {
  // URL base da API principal (auto-detecta ambiente)
  baseURL: process.env.REACT_APP_API_URL || (isLocalhost ? LOCAL_API_URL : PROD_API_URL),
  
  // URL da API do WhatsApp (sem /api no final)
  whatsappURL: process.env.REACT_APP_WHATSAPP_API_URL || (isLocalhost ? LOCAL_WHATSAPP_URL : PROD_WHATSAPP_URL),
  
  // Timeout padrão para requisições (30 segundos)
  timeout: 30000,
  
  // Flag para debug
  isLocalEnvironment: isLocalhost,
};

/**
 * Helper para construir URLs completas
 */
export const buildApiUrl = (path: string): string => {
  const url = path.startsWith('/') ? path : `/${path}`;
  return `${API_CONFIG.baseURL}${url}`;
};

export default API_CONFIG;

